/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Cell', {
    staticClass: "position-com"
  }, [_c('div', {
    staticClass: "cell-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [!_vm.hasTitleSlot ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.hasTitleSlot ? _c('div', [_vm._t("title")], 2) : _vm._e()]), _c('div', {
    staticClass: "cell-value"
  }, [_c('div', {
    staticClass: "cell-value-content"
  }, [_vm._v(" " + _vm._s(_vm.currAddressForShow) + " ")])]), _c('div', {
    staticClass: "cell-child",
    attrs: {
      "slot": "child"
    },
    on: {
      "click": _vm.position
    },
    slot: "child"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    staticClass: "icon-i",
    attrs: {
      "src": "/spa_static_mobile/icon/nav20_24@3x.png"
    }
  })])]), _c('Loading', {
    model: {
      value: _vm.loadingShow,
      callback: function ($$v) {
        _vm.loadingShow = $$v;
      },
      expression: "loadingShow"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };